import type { NotificationDTO } from "@zplanem/responses"
import type { Translations } from "@zplanem/translations"
import { webPaths } from "@zplanem/web-paths"

/**
 * One-liner + deep link for a persisted notification (ZPL-310). Pure — the
 * locale-coverage test walks every NOTIFICATION_TYPE across pl/en/uk. Copy
 * leads with the actor ("Ola wspomniała o Tobie…"); the actor name is the
 * write-time snapshot, so it renders after account deletion too.
 */
export function notificationCopy(
	t: Translations,
	n: NotificationDTO,
): { text: string; href: string } {
	const c = t.notificationsBell
	switch (n.type) {
		case "chat.mention":
			return {
				text: c.chatMention.replace("{actor}", n.actorDisplayName),
				href: n.payload.projectId
					? webPaths.project(n.propertyId ?? "", n.payload.projectId)
					: webPaths.property(n.propertyId ?? ""),
			}
		case "ticket.assigned":
			return {
				text: c.ticketAssigned
					.replace("{actor}", n.actorDisplayName)
					.replace("{title}", n.payload.title),
				href: webPaths.ticket(n.propertyId ?? "", n.payload.ticketId),
			}
		case "join-request.created":
			return {
				text: c.joinRequestCreated.replace(
					"{actor}",
					n.payload.requesterDisplayName,
				),
				href: webPaths.property(n.propertyId ?? ""),
			}
		case "agent-action.pending":
			return {
				text: c.agentActionPending,
				href: webPaths.property(n.propertyId ?? ""),
			}
	}
}
